/**
 * Trạng thái của form
 */
export default {
  /**
   * Mode View
   */
  View: 0,
  /**
   * Thêm
   */
  Add: 1,
  /**
   * Sửa
   */
  Edit: 2,
  /**
   * Nhân bản
   */
  Duplicate: 4,
  /**
   * Thêm nhanh
   */
  QuickAdd: 5,
};
